import styled from 'styled-components'

export const LabelBadge = styled.div`
  display: inline-flex;
  align-items: center;
  font: var(--theme-typography-bodyM-regular);
  color: var(--theme-colors-global-general-secondary);
  gap: 8px;
`
